<template>
  <div>
     <half-popup
      :title="gettext('邀请')"
      :isShow="isShow"
      @clickMask="clickMask"
      >
      <div slot="content">
        <div class="share">
          <div class="code-box">
            <p class="code-box-title">{{_('通过SNS邀请')}}</p>
            <div class="copy-wrap">
              <span class="code">{{recommendCode}}</span>
              <span
                v-if="clipboard"
                class="copy-btn-popup"
                :data-clipboard-text="copyContent"
                @click="copyHandle"
              >
              </span>
            </div>
          </div>
          <div class="share-box">
            <div class="title">{{gettext('将优惠分享到')}}</div>
            <share :config="shareConfig" :shortLink="true" @trackShareClick="$emit('trackShareClick')" />
          </div>
        </div>
      </div>
     </half-popup>
  </div>
</template>

<script>
import HalfPopup from '@/components/half-popup/index'
import Share from '@/page/c/xtc/modules/share.vue'
import Clipboard from 'clipboard'
import { debounce } from '@/common/js/utils'

export default {
  name: 'sharePopup',
  props: {
    // 兑换码：FOOD-J82RPF
    recommendCode: {
      type: String,
      default: ''
    },
    // 要复制的内容，比如：Hola, tu amigo te ha enviado MX$130.00 MXN de descuento para tu primer pedido. Obténlo aquí:
    copyContent: {
      type: String,
      default: ''
    },
    shareConfig: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    HalfPopup,
    Share
  },
  data () {
    return {
      isShow: true,
      clipboard: null
    }
  },
  computed: {
    country () {
      return this.$store.state.country
    },
    hostName () {
      // 巴西使用99域名,墨西哥使用didi域名
      return process.env[this.country].hostname || 'act.didi-food.com'
    }
  },
  mounted () {
    this.initClipBoard()
  },
  methods: {
    initClipBoard () {
      // TODO: 不支持clipboard兼容
      if (Clipboard.isSupported()) {
        this.clipboard = new Clipboard('.copy-btn-popup')
      }
    },
    copyHandle: debounce(function () {
      this.$emit('trackCopyClick')
      this.clipboard.on('success', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('复制成功'),
          type: 'correct'
        })
        toast.show()
        e.clearSelection()
      })
      this.clipboard.on('error', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('该浏览器不支持自动复制'),
          type: 'error'
        })
        toast.show()
        e.clearSelection()
      })
    }, 200),
    clickMask () {
      this.$emit('close')
    }
  },
  beforeDestroy () {
    this.clipboard && this.clipboard.destroy()
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/common/stylus/variables";
@import '~@/common/stylus/mixin.styl';
.item-btn{
    padding: 24px 40px;
    min-width: 288px;
    i{
      font-size: 32px;
      transform: rotate(180deg);
      display: inline-block;
      vertical-align: middle;
      margin-left: -10px;
    }
  }
.share {
  margin: 20px 0
  padding: 48px 0
  border-radius: 12px
  background: #ffffff
  .code-box {
    padding-bottom 48px
    border-bottom 1px solid #EBEBEB
    .code-box-title {
      font-family: 'Aspira Light';
      font-size: 28px;
      color: #000000;
      text-align: left;
    }
    .copy-wrap {
      margin-top: 48px;
      display flex
      align-items center
      justify-content flex-start
      .copy-btn-popup {
        display: inline-block
        width: 40px
        height: 40px
        line-height: 40px
        white-space: nowrap
        copy-icon()
        margin-left: 12px
        box-sizing: border-box
        font-size: 28px
        font-color()
      }
      .code {
        font-family: 'Aspira Medium'
        font-size: 48px
        color: #000000
        letter-spacing: 0
        text-align: center
        font-weight: bold
        -webkit-user-select: text
      }
    }
  }
  .share-box {
    margin 48px 0 0
    .title {
      font-family: 'Aspira Light';
      font-size: 28px;
      color: #000000;
      text-align: left;
      margin-bottom 18px
    }
    & ::v-deep .icons {
      padding 0
      justify-content space-between
      .icon {
        width 90px
        height 90px
        margin-left 0!important
        img {
          width 90px
          height 90px
        }
      }
    }
  }
}
</style>
<style>
.half-content .share .icons{
  justify-content: space-between!important;
  padding: 0 0 15px!important;
}
.half-content .share .icons .icon img{
  width: 90px!important;
  height: 90px!important;
}
</style>
